import { useMutation } from '@tanstack/react-query';
import type { CreateRefuelingContractRequest } from '../../api/requests/refueling-contract-request.ts';
import { createRefuelingContract } from '../../api/refueling-contract.ts';

export default function useCreateRefuelingContract() {
  return useMutation<string, Error, CreateRefuelingContractRequest>({
    mutationFn: async (req) => {
      const response = await createRefuelingContract(req);
      return response.data.id;
    },
  });
}
